import React from 'react';
import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import { callActions } from '@lifesize/nucleus';
import OtherOptions from 'components/InCall/OtherOptions';
import _get from 'lodash/get';
import { hooks } from '@lifesize/clients.sdk';

function mapDispatchToProps(dispatch) {
  return {
    onKebabClicked: () => dispatch(actions.toggleKebabExpanded()),
    openCameraControls: () => {
      dispatch(actions.toggleCameraControls());
    },
    onDTMFClicked: number => dispatch(callActions.sendDtmf(number)),
    toggleDialPad: () => {
      dispatch(actions.toggleDialPad());
    }
  };
}

const mapStateToProps = (state, ownProps) => {
  const kebabExpanded = _get(state, 'app.inCallVideo.kebabExpanded');
  const canControlFarEndCamera = ownProps.canControlFarEndCamera;
  return {
    kebabExpanded,
    canControlFarEndCamera
  };
};

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(OtherOptions);

const FunctionalWrapper = (props) => {
  const canControlFarEndCamera = hooks.useCanControlFarEndCamera();
  return (<ConnectedComponent {...props} canControlFarEndCamera={canControlFarEndCamera} />)
}

export default FunctionalWrapper;
